import { useEffect, useState } from 'react';

export const useWindowSize = () => {
  const [size, setSize] = useState<{
    readonly width: number | null;
    readonly height: number | null;
  }>({ width: null, height: null });
  useEffect(() => {
    function resize() {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    }
    window.addEventListener('resize', resize);
    resize();
    return () => window.removeEventListener('resize', resize);
  }, []);
  return { size };
};
